import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

import {
  HeaderComponent,
  FooterComponent,
  ModalComponent,
  IsiComponent,
  MedicineComponent,
  VideoPlayerComponent,
  ChatComponent,
  MobileWarningComponent
} from './components';

import {
  RoomComponent,
  SplashComponent,
  LoadingComponent
} from './pages';

import {
  WelcomeComponent,
  ThankyouComponent,
  BasicModalComponent,
  ConnectComponent,
  MediaComponent,
  LeavingComponent,
  OldIeComponent
} from './modals';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    RoomComponent,
    ModalComponent,
    WelcomeComponent,
    IsiComponent,
    MedicineComponent,
    VideoPlayerComponent,
    ChatComponent,
    SplashComponent,
    ThankyouComponent,
    LoadingComponent,
    MobileWarningComponent,
    ConnectComponent,
    MediaComponent,
    LeavingComponent,
    OldIeComponent,
    BasicModalComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    RoomComponent,
    ModalComponent,
    WelcomeComponent,
    IsiComponent,
    MedicineComponent,
    VideoPlayerComponent,
    ChatComponent,
    SplashComponent,
    ThankyouComponent,
    LoadingComponent,
    MobileWarningComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    PdfViewerModule,
    PdfJsViewerModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
